import { render, staticRenderFns } from "./index.vue?vue&type=template&id=701b695e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701b695e')) {
      api.createRecord('701b695e', component.options)
    } else {
      api.reload('701b695e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=701b695e", function () {
      api.rerender('701b695e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChangePassword/index.vue"
export default component.exports